import React, { useEffect } from 'react'
import styles from '../registration.module.scss'
import i18n from 'constants/strings'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'
import { getFastTrackPersonDetails } from 'actions/fastTrackReg-actions'
import { MessageTypes } from 'constants/message-screens'
import BtnPrimary from 'components/generic/BtnPrimary'
import LoadingSpinner from '../common/LoadingSpinner'
import { CONTACT_US_HREF } from 'constants/global'
import classNames from 'classnames'
import ExistingItfCustomerText from '../common/ExistingItfCustomerText'
import ResponsiveText from 'components/generic/ResponsiveText'
import ErrorScreen from 'components/generic/ErrorScreen'
import { startRegistrationFlowExistingCustomer } from '../utils'
import { createRegLog } from 'modules/reg-logger'

interface Props {
  regToken: string
}

const WelcomeExistingItfCustomer = ({ regToken }: Props) => {
  const dispatch = useDispatch()
  const personDetails = useSelector((state: AppState) => state.fastTrackReg.personDetails)
  const loading = useSelector((state: AppState) => state.fastTrackReg.loadingPersonDetails)
  const error = useSelector((state: AppState) => state.fastTrackReg.error)

  const title = `${i18n.t('strFastTrackRegistration.welcome')} ${personDetails?.firstName} ${
    personDetails?.lastName
  }`

  useEffect(() => {
    createRegLog('alreadyCustomerWU')
    dispatch(getFastTrackPersonDetails(regToken))
  }, [dispatch, regToken])

  if (error)
    return (
      <ErrorScreen
        type={MessageTypes.FAST_TRACK_ERROR}
        message={error.message}
        backLink={CONTACT_US_HREF}
      />
    )

  if (loading || !personDetails) return <LoadingSpinner />

  return (
    <>
      <ResponsiveText as={'h1'} compareString={title} classLongText={styles.smallTitle}>
        {title}
      </ResponsiveText>

      <p className={styles.introText}>
        <ExistingItfCustomerText />
      </p>

      <BtnPrimary
        size={'medium'}
        className={classNames(styles.submitBtn, styles.mt12)}
        onClick={startRegistrationFlowExistingCustomer}
      >
        {i18n.t('strCommonUI.button.continue')}
      </BtnPrimary>
    </>
  )
}

export default WelcomeExistingItfCustomer
